import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "hearth.cookies-ack";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setShow(true);
    } catch (e) {
      console.warn("CookieBanner: localStorage read failed, showing banner:", e);
      setShow(true);
    }
  }, []);

  const ack = () => {
    try { localStorage.setItem(STORAGE_KEY, new Date().toISOString()); } catch (e) { console.warn("CookieBanner: localStorage write failed:", e); }
    setShow(false);
  };

  if (!show) return null;
  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-md z-50 bg-white border border-[#e5e2d9] shadow-lg rounded-[4px] p-4 flex items-start gap-3 animate-fade-up"
    >
      <Cookie className="w-4 h-4 mt-0.5 text-[#c0612f] shrink-0" strokeWidth={1.8} />
      <div className="flex-1 text-sm text-[#1c1917]">
        <div className="font-medium">A note on cookies</div>
        <div className="text-xs text-[#57534e] mt-1 leading-relaxed">
          We only use strictly-necessary cookies to keep you signed in. No analytics, no trackers.
          {" "}<Link to="/legal/cookies" className="underline text-[#1b3b36]" data-testid="cookie-banner-learn-more">Learn more</Link>.
        </div>
        <div className="mt-3 flex items-center gap-2">
          <button
            type="button"
            data-testid="cookie-banner-ok"
            onClick={ack}
            className="text-xs uppercase tracking-[0.2em] bg-[#1b3b36] hover:bg-[#2c5a53] text-white px-3 py-2 rounded-[3px] transition-colors"
          >
            Got it
          </button>
        </div>
      </div>
      <button
        type="button"
        onClick={ack}
        aria-label="Dismiss"
        className="text-[#8a8476] hover:text-[#1c1917]"
        data-testid="cookie-banner-close"
      >
        <X className="w-4 h-4" strokeWidth={1.8} />
      </button>
    </div>
  );
}
